import { isSameDay, subHours } from 'date-fns';
import { PropertyType } from '../../../common';

const mapLogs = (logs: PropertyType[]) => {
	const mappedLogs = [...logs];
	let currentDate = new Date('01-01-2000');

	mappedLogs.forEach((l) => {
		const actDate = new Date(l.created_at);
		const lastActDate = new Date(l.user.last_activity_at);
		const tzDate = subHours(actDate, 1);
		const lastAct = subHours(lastActDate, 1);

		l.created_at = tzDate;
		l.user = { ...l.user, last_activity_at: lastAct };

		if (!isSameDay(tzDate, currentDate)) {
			l.groupDate = tzDate;
			currentDate = tzDate;
		}
	});

	return mappedLogs;
};

export const mapApiToEntity = (data: PropertyType): PropertyType => ({
	logs: mapLogs(data.data),
	pagesTotal: data.last_page,
});

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	page: data.page,
	per_page: data.perPage || 10,
});
